import { put, race, select, take } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import * as intersections from '../requests/intersection-counts-req';
import { selectSchedulePopoverDataId } from '../selectors';
import { SCHEDULE_VALIDATE_TYPES, scheduleValidateActions } from '../validate';

export function* findIntersections({ workSlot, id }) {
  const { scheduleSettingAttributes } = workSlot;

  yield put(intersections.actions.send({ id, ...scheduleSettingAttributes }));

  const { succeed, failed } = yield race({
    succeed: take(intersections.actions.succeed),
    failed: take([
      intersections.actions.rejected,
      intersections.actions.errorEncountered,
    ]),
  });

  if (failed) {
    return false;
  }

  const {
    payload: {
      ids: { workSlots },
    },
  } = succeed;

  const selectedScheduleId = yield select(selectSchedulePopoverDataId);

  if (
    selectedScheduleId &&
    workSlots.length === 1 &&
    workSlots[0] === selectedScheduleId
  ) {
    return true;
  }

  /**
   *  DISPLAY OVERLAP SCHEDULE MODAL
   * */
  if (!isEmpty(workSlots)) {
    yield put(scheduleValidateActions.toggleOverlapModal(true));
    yield take(SCHEDULE_VALIDATE_TYPES.FORCE_OVERLAP);
    return true;
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/find-intersections-saga.js